@if (productData && hasValidTranslations) {
<section class="section-0">
    @for (sideBySideKeys of groupedContent['SECTION-0_SIDE-BY-SIDE']; track
    sideBySideKeys; let i = $index) { @if ( sideBySideKeys.buttonText ||
    sideBySideKeys.buttonUrl || sideBySideKeys.descriptionText ||
    sideBySideKeys.headingText || sideBySideKeys.imageUrl ||
    sideBySideKeys.imageAltText || sideBySideKeys.linkText ||
    sideBySideKeys.linkUrl || sideBySideKeys.videoId ) {

    <vision2-side-by-side
        [buttonText]="sideBySideKeys.buttonText"
        [buttonUrl]="sideBySideKeys.buttonUrl"
        [description]="sideBySideKeys.descriptionText"
        [heading]="sideBySideKeys.headingText"
        [headingValue]="2"
        [image]="sideBySideKeys.imageUrl"
        [imageAlt]="sideBySideKeys.imageAltText"
        [linkText]="sideBySideKeys.linkText"
        [linkUrl]="sideBySideKeys.linkUrl"
        [modalVideoId]="sideBySideKeys.videoId"
        [centered]="true"
        [colorClass]="'text-bg-gray-30'"
        [contentColor]="'bg-transparent'"
        [type]="'right'"
        [contentClass]="'col-sm-10 col-lg-6 col-xl-4'"
        [imageClass]="'col-sm-10 col-lg-6 col-xl-5 offset-xl-1'"
        [contentPadding]="'featured-product-padding'"
        [verticalPadding]="'py-4'"
    ></vision2-side-by-side>
    } } @if (groupedContent['SECTION-0_CONTENT-BLOCK']?.length > 0 &&
    hasTranslationValues(groupedContent['SECTION-0_CONTENT-BLOCK'])) {
    <div class="container my-6 my-lg-7">
        <div class="row g-0 justify-content-center">
            <div class="col-12 col-xl-10">
                <div class="row g-2 g-lg-3 g-xl-4 justify-content-center">
                    @for (contentBlockKeys of
                    groupedContent['SECTION-0_CONTENT-BLOCK']; track
                    contentBlockKeys; let i = $index) { @if (
                    contentBlockKeys.buttonText || contentBlockKeys.buttonUrl ||
                    contentBlockKeys.descriptionText ||
                    contentBlockKeys.headingText || contentBlockKeys.imageUrl ||
                    contentBlockKeys.imageAltText || contentBlockKeys.linkText
                    || contentBlockKeys.linkUrl || contentBlockKeys.videoId ) {
                    <div class="col-12 col-md-6">
                        <vision2-card
                            [buttonText]="contentBlockKeys.buttonText"
                            [buttonUrl]="contentBlockKeys.buttonUrl"
                            [description]="contentBlockKeys.descriptionText"
                            [image]="contentBlockKeys.imageUrl"
                            [imageAlt]="contentBlockKeys.imageAltText"
                            [imageClass]="'rounded-4 w-100'"
                            [imageSizes]="'(min-width: 768px) 50vw, 100vw'"
                            [linkUrl]="contentBlockKeys.linkUrl"
                            [linkText]="contentBlockKeys.linkText"
                            [title]="contentBlockKeys.headingText"
                            [cardClass]="'pt-4 px-2 mx-auto text-center'"
                            [cardColor]="'bg-transparent'"
                        ></vision2-card>
                    </div>
                    } }
                </div>
            </div>
        </div>
    </div>
    }
</section>
}
